import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { Input } from '../../../../input'
import { FONTS } from '../../../../../constants'
import { formatNumber } from '../../../../../function/math'

export const hardware_type = [
  { label: 'Hardware', value: 'HARDWARE' },
  { label: 'MA', value: 'HARDWARE_MA' },
]

export const credit_term = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '90', value: '90' },
]

export const InputRow = (props) => {
  const {
    idx,
    crType,
    changeRequest,
    handleInput,
  } = props
  const type = crType.find(t => t.value === changeRequest.cr_type)
  const creditTerm = credit_term.find(t => t.value === changeRequest.credit_term)

  return (
    <Root>
      <Text>{ type ? type.label : '-' }</Text>
      <Text>{ changeRequest.qt_number || '-' }</Text>
      <Input
        name='name'
        placeholder='Enter Change Request'
        value={ changeRequest.sub_project_code }
        onChange={ e => handleInput({ cr_id: changeRequest.cr_id, sub_project_code: e.target.value }, 'change_requests', idx) }
      />
      <Text>{ changeRequest.description || '-' }</Text>
      <Text>{ changeRequest.delivery_date ? moment(changeRequest.delivery_date).format('DD/MM/YYYY') : '-' }</Text>
      <Text>{ creditTerm ? creditTerm.label : '-' }</Text>
      <Text>{ changeRequest.man_days || '-' }</Text>
      <Number>{ formatNumber(changeRequest.cost) || '-' }</Number>
      <Number>{ formatNumber(changeRequest.price) || '-' }</Number>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 46px;
  display: grid;
  align-items: center;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  padding: 0 24px;
  background: #FFFFFF;
  margin-top: 1px;

  :nth-child(1) {
    margin: 0;
  }
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`

const Number = styled(Text)`
  text-align: right;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-change-request/input-row.js